import { useEffect, useState } from "react";

/**
 * Mirrors `active`, but only flips to true once it has stayed true continuously for
 * `delay` ms - so a fast background refresh never flashes a loader, while a slow one
 * still shows one. Flips back to false immediately as soon as `active` clears.
 */
const useDelayedFlag = (active, delay = 400) => {
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        if (!active) {
            setFlag(false);
            return;
        }
        const timeout = setTimeout(() => setFlag(true), delay);
        return () => clearTimeout(timeout);
    }, [active, delay]);

    return flag;
};

export default useDelayedFlag;
